import apiClient from '@/services/api/apiClient';
import { QueryParams } from '@/model';
import { buildApiUrl } from '../utils';
import { GetDashboardUserByIdResponse, GetDashboardUserResponse, PostDashboardUserResponse } from '../response/dashboard-user';
import {
  PostDashboardUserRequest,
  PutDashboardUserPasswordRequest,
  PutDashboardUserRequest,
  PutDashboardUserRequestAvatar,
} from '../request/dashboard-user';

export class DashboardUserService {
  static getDashboardUser(params?: QueryParams) {
    return apiClient.get<GetDashboardUserResponse>(buildApiUrl('/api/v1/dashboard-user'), params);
  }

  static postDashboardUser(data: PostDashboardUserRequest) {
    return apiClient.post<PostDashboardUserResponse>(buildApiUrl('/api/v1/dashboard-user'), data);
  }

  static putDashboardUser(id: string, data: PutDashboardUserRequest) {
    const url = buildApiUrl('/api/v1/dashboard-user/:id', { id });
    return apiClient.update<void>(url, data);
  }

  static getDashboardUserById(id: string) {
    const url = buildApiUrl('/api/v1/dashboard-user/:id', { id });
    return apiClient.get<GetDashboardUserByIdResponse>(url, undefined);
  }

  static putDashboardUserAvatar(id: string, data: PutDashboardUserRequestAvatar) {
    const url = buildApiUrl('/api/v1/dashboard-user/:id/avatar', { id });
    return apiClient.updateWithFile<void>(url, data);
  }

  static putDashboardUserPassword(id: string, data: PutDashboardUserPasswordRequest) {
    const url = buildApiUrl('/api/v1/dashboard-user/:id/password', { id });
    return apiClient.update<void>(url, data);
  }

  static deleteDashboardUser(id: string) {
    const url = buildApiUrl('/api/v1/dashboard-user/:id', { id });
    return apiClient.delete<void>(url);
  }
}
